/* nue daily — dynamic delivery date (M2) */
(function () {
  'use strict';

  var CUTOFF_HOUR_SYDNEY = 14;
  var TRANSIT_BUSINESS_DAYS = 3;
  var SYDNEY_TZ = 'Australia/Sydney';

  var AU_HOLIDAYS = [
    '2026-01-01','2026-01-26','2026-04-03','2026-04-04','2026-04-05',
    '2026-04-06','2026-04-25','2026-06-08','2026-10-05','2026-12-25',
    '2026-12-26','2026-12-28',
    '2027-01-01','2027-01-26','2027-03-26','2027-03-27','2027-03-28',
    '2027-03-29','2027-04-25','2027-04-26','2027-06-14','2027-10-04',
    '2027-12-25','2027-12-27','2027-12-28'
  ];

  function toSydneyISODate(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: SYDNEY_TZ, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(date);
    return parts.find(p => p.type==='year').value + '-' +
           parts.find(p => p.type==='month').value + '-' +
           parts.find(p => p.type==='day').value;
  }
  function sydneyHour(date) {
    var parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: SYDNEY_TZ, hour: '2-digit', hour12: false
    }).formatToParts(date);
    return parseInt(parts.find(p => p.type==='hour').value, 10);
  }
  function sydneyDayOfWeek(date) {
    var name = new Intl.DateTimeFormat('en-AU', {
      timeZone: SYDNEY_TZ, weekday: 'long'
    }).format(date);
    return {Sunday:0,Monday:1,Tuesday:2,Wednesday:3,Thursday:4,Friday:5,Saturday:6}[name];
  }
  function isBusinessDay(iso) {
    var d = new Date(iso + 'T12:00:00');
    var dow = sydneyDayOfWeek(d);
    if (dow === 0 || dow === 6) return false;
    return AU_HOLIDAYS.indexOf(iso) === -1;
  }
  function addOneDay(iso) {
    var d = new Date(iso + 'T12:00:00');
    d.setUTCDate(d.getUTCDate() + 1);
    return toSydneyISODate(d);
  }
  function addBusinessDays(iso, n) {
    var cur = iso, added = 0;
    while (added < n) { cur = addOneDay(cur); if (isBusinessDay(cur)) added++; }
    return cur;
  }
  function shipDate(now) {
    var today = toSydneyISODate(now);
    if (sydneyHour(now) < CUTOFF_HOUR_SYDNEY && isBusinessDay(today)) return today;
    var next = addOneDay(today);
    while (!isBusinessDay(next)) next = addOneDay(next);
    return next;
  }
  function formatHuman(iso) {
    var d = new Date(iso + 'T12:00:00');
    var parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: SYDNEY_TZ, weekday: 'long', day: 'numeric', month: 'long'
    }).formatToParts(d);
    return (parts.find(p=>p.type==='weekday').value + ', ' +
            parts.find(p=>p.type==='day').value + ' ' +
            parts.find(p=>p.type==='month').value).toLowerCase();
  }
  function render() {
    try {
      var targets = document.querySelectorAll('[data-nue-delivery]');
      if (!targets.length) return;
      var ship = shipDate(new Date());
      var arrive = addBusinessDays(ship, TRANSIT_BUSINESS_DAYS);
      var label = 'estimated delivery: ' + formatHuman(arrive) + '*';
      targets.forEach(function (el) { el.textContent = label;
el.setAttribute('data-nue-delivery-rendered', '') });
    } catch (e) { if (window.console) console.warn('nue-delivery:', e); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else { render(); }
  document.addEventListener('variant:change', render);
})();